import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PageContentItem } from '../../../shared/model/store.models';

@Component({
  selector: 'clearcals-store-faq',
  templateUrl: './store-faq.component.html',
  styleUrls: ['./store-faq.component.scss']
})
export class StoreFaqComponent implements OnInit {
  @Input() pageContent$ = new BehaviorSubject<PageContentItem[]>([]);

  constructor() { }

  ngOnInit(): void {
  }

}
